<template>
  <div class="sale-target-container default-table">
    <div class="head">
      <el-date-picker
          v-model="queryParams.year"
          value-format="yyyy"
          :clearable="false"
          format="yyyy年"
          size="mini"
          type="year"
          placeholder="选择年份"
          editable
          @change="handleSearch"/>
      <el-input @change="handleSearch" clearable style="width: 300px;margin:0 10px" v-model="queryParams.sale_nm"
                placeholder="模糊查询销售名称" size="mini"/>
      <el-button type="primary" size="mini" @click="handleSearch" :loading="loading" :disabled="loading">
        查询
      </el-button>
      <el-button type="primary" size="mini" @click="addBtn" icon="el-icon-plus">新增</el-button>
    </div>

    <div class="data-table-container" style="width: 80%">
      <div class="table-wrapper">
        <div v-loading='loading' element-loading-text='玩命加载中……' element-loading-spinner='el-icon-loading'>
          <el-table :data="tableData" border width="800" height="500">
            <el-table-column type="index" label="序号" width="65" align="center" header-align="center" />
            <el-table-column prop="sale_nm" label="销售" width="100" align="center" header-align="center" />
            <el-table-column prop="org_nm" label="部门" width="100" align="center" header-align="center" />
            <el-table-column prop="year" label="年份" width="80" align="center" header-align="center" />
            <el-table-column prop="amount" label="年度目标(万)" width="150" align="right" header-align="center" />
            <el-table-column prop="updated_at" label="设置时间" width="150" align="center" header-align="center" />
            <el-table-column label="操作" width="80" align="center" header-align="center">
              <template slot-scope="{row}" v-if="row.id">
                <el-link type="primary" icon="el-icon-edit" @click="editBtn(row)">修改</el-link>
                <el-link type="warning" icon="el-icon-delete" style="margin-left: 20px" @click="deleteBtn(row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              background
              @size-change='handleSizeChange'
              @current-change='handleCurrentChange'
              :current-page='pages.current_page'
              :page-sizes="[5, 10, 20, 100, 200]"
              :page-size='pages.per_page'
              layout="total, sizes, prev, pager, next"
              :total='pages.total'
              style="position:relative; bottom: auto !important; left: 35% !important;">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog
        :title="formData.title"
        :visible.sync="formData.is_show"
        width="500px"
        center
        :close-on-click-modal="false"
        @closed="saleTargetDialogClose">
      <el-form ref="saleTargetForm" label-width="120px" :model="formData.form" size="mini" label-suffix="：">
        <el-form-item label="销售名称">
          <el-select v-show="!formData.form.id" v-model="formData.form.sale_id" placeholder="请选择销售" filterable>
            <el-option v-for="item in saleUserOptions" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <span v-show="formData.form.id">{{ formData.form.sale_nm || '' }}</span>
        </el-form-item>
        <el-form-item prop="amount" label="年度目标">
          <el-input v-model="formData.form.amount" maxlength="20" placeholder="请填写年度目标" style="width: 200px;">
            <i slot="prepend">￥</i>
            <i slot="append">万</i>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formData.is_show = false">取 消</el-button>
        <el-button type="primary" @click="handelSaleTargetSubmit" :loading="formData.submitLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getSaleTargetList, saveSaleTargetRow, deleteSaleTargetRow, getSaleUserOptions} from "@/api/saleTarget";
import {gFunc} from "@/globalFunc";

const ConfigPage = {
  layout: 'total, sizes, prev, pager, next, jumper',
  total: 0,
  page_size: 20,
  current_page: 1,
}
export default {
  name: "saleTarget",
  data() {
    return {
      configPage: ConfigPage,
      loading: false,
      queryParams: {year: null, sale_nm: null},
      saleUserOptions: [],
      tableData: [],
      pages: {
        total: 0,
        last_page: 0,
        per_page: 0,
        current_page: 1,
        offset: 0,
      },
      formData: {
        title: "",
        suffix: "设置年度目标",
        is_show: false,
        submitLoading: false,
        form: {
          id: null,
          sale_id: null,
          year: null,
          target_at: "",
          amount: 0,
          sale_nm: "",
        }
      },
    }
  },
  computed: {
    gFunc() {
      return gFunc
    },
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  created() {
    this.defaultYear()
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    handleSearch() {
      this.pages.current_page = 1
      this.getTableData()
    },
    getParams() {
      const params = this.handleSearchCondition()
      Object.assign(params, {
        page_size: this.pages.page_size,
        current_page: this.pages.current_page
      })
      return params
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.queryParams).forEach((key) => {
        if (this.queryParams[key]) {
          condition[key] = this.queryParams[key]
        }
      })

      if (condition.year) {
        condition.target_at = condition.year + '-01-01'
      }

      return condition
    },
    async getTableData() {
      if (this.queryParams.year) {
        this.loading = true
        const { model: { list, pages } } = await getSaleTargetList(this.getParams())
        this.tableData = list || []
        this.pages = pages
        this.pages.total = pages.total || 0
        this.loading = false
      } else {
        this.$message.warning('年份必选')
      }
    },
    defaultYear() {
      let date = new Date();
      this.queryParams.year = date.getFullYear() + ''
    },
    addBtn() {
      this.formData.title = '设置销售的' + this.queryParams.year + '年度目标'
      this.$nextTick(async () => {
        const {model: {options}} = await getSaleUserOptions()
        this.saleUserOptions = options
        this.formData.form.year = this.queryParams.year
        this.formData.form.target_at = this.queryParams.year + '-01-01'
      })
      this.formData.is_show = true
    },
    editBtn(row) {
      this.formData.title = '设置销售的' + this.queryParams.year + '年度目标'
      this.formData.form = row
      this.formData.form.target_at = this.queryParams.year + '-01-01'
      this.formData.is_show = true
    },
    deleteBtn(row) {
      if (row.id) {
        this.$confirm(`确认删除【${row.sale_nm || '-'}】【${row.year || '-'}】年的目标(${row.amount || 0}万)？？？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { model } = await deleteSaleTargetRow({ id: row.id })
          if (model) {
            this.$message.success('删除成功')
            await this.getTableData()
          } else {
            this.$message.error('删除失败')
          }
        }).catch(() => {
          this.$message.info('删除已取消')
        })
      } else {
        this.$message.warning('删除对象ID为空')
      }
    },
    async handelSaleTargetSubmit() {
      this.formData.submitLoading = true
      const { model, message } = await saveSaleTargetRow(this.formData.form)
      if (model.id) {
        this.$message.success('保存成功')
        this.formData.is_show = false
        await this.getTableData()
      } else {
        this.$message.error(message)
      }
      this.formData.submitLoading = false
    },
    saleTargetDialogClose() {
      this.formData.form = {
        id: null,
        sale_id: null,
        year: null,
        target_at: '',
        amount: 0,
        sale_nm: '',
      }
      this.formData.submitLoading = false
    },
    // pageSize 改变时处理
    handleSizeChange(val) {
      // this.pageSize = val
      this.apePageSize = val
      this.currentPage = 1
      this.switchPaging()
      //滚动顶部
      if (this.scrollToTop)
        scrollTo(0, 800)
    },
    // currentPage 改变时处理
    handleCurrentChange(val) {
      this.currentPage = val
      this.switchPaging()
      //滚动顶部
      if (this.scrollToTop)
        scrollTo(0, 800)
    },
    // 切换页码操作
    async switchPaging() {
      this.handleSearch()
    }
  }
}
</script>

<style lang="scss">
.sale-target-container {
  padding: 10px !important;

  .head {
    margin: 10px 0;
  }

  .customer {
    display: inline-block;
    margin: 10px;

    .el-select {
      width: 300px !important;
    }
  }

  .el-pagination {
    position: absolute;
    bottom: 0 !important;
    right: 0 !important;
  }

  .tip-time {
    > * {
      color: #8a8e99;
      font-size: 12px;
      margin-right: 10px;
      float: right;
      line-height: 48px;
    }
  }

  .el-input-group__prepend {
    padding-left: 10px;
    padding-right: 5px;
  }
  .el-input-group__append {
    padding-left: 5px;
    padding-right: 10px;
  }
}
</style>
